import React from 'react';
//@ts-ignore
import logo from '!url-loader!../assets/images/logo_white.png';
function LoadingAnimation(_a) {
    var message = _a.message;
    return (React.createElement("div", { className: "loading" },
        React.createElement("img", { src: logo }),
        React.createElement("p", null, message ? message : 'Loading...')));
}
export default LoadingAnimation;
